class Vault {
  keys = {
    AUTH_TOKEN: 'authToken',
    PUSH_TOKEN: 'pushToken',
    USER_ID: 'userId',
  }

  constructor() {
    this.prefix = 'Market2Day';
    this.queues = Object.values(this.keys).reduce((o, k) => ({ ...o, [this.buildKey(k)]: [] }), {});
  }

  store = (key, value) => {
    if (value === null || value === undefined) {
      return this.remove(key);
    }

    const id = this.buildKey(key);
    return localStorage.setItem(id, value);
  }

  get = (key) => {
    const id = this.buildKey(key);
    return new Promise((resolve, reject) => {
      let value;
      try {
        value = localStorage.getItem(id);
      } catch {
        return reject(new Error(`${id} Not Found`));
      }
      if (value) {
        return resolve(value);
      }
      return reject(new Error(`${id} Falsy`));
    });
  }

  remove = (key) => {
    const id = this.buildKey(key);
    localStorage.removeItem(id);
  }

  empty = () => {
    const keys = Object.values(this.keys).map(this.buildKey);
    keys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  buildKey = (k) => `${this.prefix}:${k}`

  handlerName = () => `vault:${this.prefix}`
}

export default new Vault();
